import { RuntimeThemeParameters, ThemeParameters } from '../../types';
import { DeepReadonly } from '../../../util/utility-types';
import { callStructWithArgs } from '../../render/react';
import colors from '../colors';
import {
  graphAxisLines,
  graphBackFill,
  graphDataNode,
  graphDataStyle,
  graphDataText,
  graphDefault,
  graphFocus,
  graphGridLines,
  graphKPIRange,
  graphLabelText,
  graphNodeDetails,
  graphNodeGroupClosed,
  graphNodeGroupOpen,
  graphNodeGroupTitle,
  graphNodeLabel,
  graphNodeLink,
  graphNodeTitle,
  graphOutlines,
  graphOutlinesUnfilled,
  graphOverviewAxis,
  graphOverviewAxisFilter,
  graphOverviewBorderLines,
  graphOverviewFill,
  graphOverviewFilterFill,
  graphOverviewViewportBorderLines,
  graphSelection,
  graphTargetNode,
  graphThreeColorRamp,
  graphValueText,
  graphWallFill,
} from '../patterns';

export type GraphTokens = ReturnType<typeof renderReactGraphTokens>;

export function renderReactGraphTokens(theme: ThemeParameters, parameters: RuntimeThemeParameters) {
  const gt = {
    c: callStructWithArgs(colors, theme),
    graphAxisLines: graphAxisLines(theme, parameters),
    graphBackfill: graphBackFill(theme, parameters),
    graphDataNode: callStructWithArgs(graphDataNode, theme, parameters),
    graphDataStyle: callStructWithArgs(graphDataStyle, theme, parameters),
    graphDataText: graphDataText(theme, parameters),
    graphDefault: graphDefault(theme, parameters),
    graphFocus: graphFocus(theme, parameters),
    graphGridLines: graphGridLines(theme, parameters),
    graphKPIRange: callStructWithArgs(graphKPIRange, theme, parameters),
    graphLabelText: graphLabelText(theme, parameters),
    graphNodeDetails: graphNodeDetails(theme, parameters),
    graphNodeGroupClosed: graphNodeGroupClosed(theme, parameters),
    graphNodeGroupOpen: graphNodeGroupOpen(theme, parameters),
    graphNodeGroupTitle: graphNodeGroupTitle(theme, parameters),
    graphNodeLabel: graphNodeLabel(theme, parameters),
    graphNodeLink: graphNodeLink(theme, parameters),
    graphNodeTitle: graphNodeTitle(theme, parameters),
    graphOutlines: graphOutlines(theme, parameters),
    graphOutlinesUnfilled: graphOutlinesUnfilled(theme, parameters),
    graphOverviewAxis: graphOverviewAxis(theme, parameters),
    graphOverviewAxisFilter: graphOverviewAxisFilter(theme, parameters),
    graphOverviewBorderLines: graphOverviewBorderLines(theme, parameters),
    graphOverviewFill: graphOverviewFill(theme, parameters),
    graphOverviewFilterFill: graphOverviewFilterFill(theme, parameters),
    graphOverviewViewportBorderLines: graphOverviewViewportBorderLines(theme, parameters),
    graphSelection: graphSelection(theme, parameters),
    graphTargetNode: graphTargetNode(theme, parameters),
    graphThreeColorRamp: callStructWithArgs(graphThreeColorRamp, theme, parameters),
    graphValueText: graphValueText(theme, parameters),
    graphWallFill: graphWallFill(theme, parameters),
  };

  return gt as DeepReadonly<typeof gt>;
}
